import React from "react";

function Canvas_Drawing() {
  return (
    <div>
      <h1>Canvas_Drawing Component</h1>
      <p>This is the Canvas Drawing tutorial page content.</p>
    </div>
  );
}

export default Canvas_Drawing;
